var map = {
	"./1.png": 60658,
	"./2.png": 75273,
	"./3.png": 97152,
	"./4.png": 48479,
	"./5.png": 51542,
	"./6.png": 65517,
	"./7.png": 11620,
	"./8.png": 55491,
	"./9.png": 7738,
	"./komprimovane/1.png": 72529,
	"./komprimovane/2.png": 51418,
	"./komprimovane/3.png": 15523,
	"./komprimovane/4.png": 39276,
	"./komprimovane/5.png": 91541,
	"./komprimovane/6.png": 5790,
	"./komprimovane/7.png": 58279,
	"./komprimovane/8.png": 57184,
	"./komprimovane/9.png": 35305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43184;